import React from "react";
import classnames from "classnames";

import "./index.scss";

const VerticalDivider = () => <div className={classnames("vertical-divider")} />;

export default VerticalDivider;
